import { Box, Container } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { toggleFormCourse } from '../../../../../redux/actions/courses'
import { IRootState } from '../../../../../redux/types'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import ActionsSection from '../components/ActionsSection'
import CoursesModal from '../components/CoursesModal'
import CoursesNotifications from '../components/CoursesNotifications'
import HeaderSection from '../components/HeaderSection'
import TitleSection from '../components/TitleSection'
import CoursesTable from '../components/table/CoursesTable'
import { useCourses } from '../hooks/useCourses'
import ConfirmDeleteDialog from '../components/ConfirmDeleteDialog'

function Courses() {
  const dispatch = useDispatch()
  const isMobile = useScreenWidth(700)
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  const {
    courseState: { showForm, courses, loading },
    coursetypes,
    tags,
    filters,
    openDeleteCourse,
    courseSelected,
    rowsSelected,
    globalBrandId,
    handleChangeFilter,
    handleClickHighlight,
    handleClickSetOptions,
    handleSubmitMassAssignment,
    handleEditCourse,
    handleDeleteCourse,
    setRowsSelected,
    setOpenDeleteCourse,
    handleOrganizeCourses
  } = useCourses()

  return (
    <>
      {showForm && <CoursesModal />}
      <HeaderSection filters={filters} coursetypes={coursetypes} handleChangeFilter={handleChangeFilter as any} />
      <Container maxWidth="lg">
        {authUser !== null && (
          <Box>
            <Box mt={isMobile ? 2 : 6} gap={isMobile ? 4 : 16} display="flex" flexDirection={isMobile ? 'column-reverse' : 'column'}>
              <TitleSection />
              <Box>
                <ActionsSection
                  rowsSelected={rowsSelected}
                  tags={tags}
                  onCreateCourse={() => dispatch(toggleFormCourse())}
                  onMassAssignment={handleSubmitMassAssignment}
                  onFilterChange={handleClickSetOptions}
                  onOrganizeCourses={handleOrganizeCourses}
                />
              </Box>
            </Box>
            <CoursesTable
              courses={courses}
              loading={loading}
              onEdit={handleEditCourse}
              onDelete={handleDeleteCourse}
              onHighlight={handleClickHighlight}
              onSelectionChange={rows => setRowsSelected(rows)}
              handleClickSetOptions={handleClickSetOptions}
              globalBrandId={globalBrandId}
            />
          </Box>
        )}
      </Container>
      <ConfirmDeleteDialog courseSelected={courseSelected} openDeleteCourse={openDeleteCourse} setOpenDeleteCourse={setOpenDeleteCourse} />
      <CoursesNotifications />
    </>
  )
}

export default Courses
